/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AssignMasterScheduleAllocationRequest } from '../../models/assign-master-schedule-allocation-request';
import { GetMasterScheduleAllocationsResponse } from '../../models/get-master-schedule-allocations-response';

export interface AssignMasterScheduleAllocations$Params {
      body: AssignMasterScheduleAllocationRequest
}

export function assignMasterScheduleAllocations(http: HttpClient, rootUrl: string, params: AssignMasterScheduleAllocations$Params, context?: HttpContext): Observable<StrictHttpResponse<GetMasterScheduleAllocationsResponse>> {
  const rb = new RequestBuilder(rootUrl, assignMasterScheduleAllocations.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetMasterScheduleAllocationsResponse>;
    })
  );
}

assignMasterScheduleAllocations.PATH = '/api/scheduler/master-schedule/allocations';
